import React from 'react';
export function AsSeenIn() {
  const logos = [{
    name: 'WebMD',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1L2UoLcRZ92cvVYGErvdo2/WebMD_logo.png',
    height: 'h-8'
  }, {
    name: 'GQ',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rWAcVi4b1KuhkosoHzmQQz/gq-logo-png-transparent_%281%29.webp',
    height: 'h-10'
  }, {
    name: 'Healthline',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wDUqsVGFHd9aYcAp7ttfN2/Healthline_logo.svg.png',
    height: 'h-7'
  }, {
    name: "Women's Health",
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hrbevUyBZ6g8BvMwZUF3eW/Womenshealthlogo.svg.webp',
    height: 'h-8'
  }];
  return <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-8 my-12 border border-gray-200" data-id="element-37">
      <h3 className="text-center text-sm font-semibold text-gray-500 uppercase tracking-wider mb-6" data-id="element-38">
        As Seen In
      </h3>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center max-w-4xl mx-auto mb-6" data-id="element-39">
        {logos.map((logo, index) => <div key={index} className="flex items-center justify-center opacity-70 hover:opacity-100 transition-opacity" data-id="element-40">
            <img src={logo.url} alt={logo.name} className={`${logo.height} w-auto object-contain`} data-id="element-41" />
          </div>)}
      </div>

      {/* Quote Section */}
      <div className="border-t border-gray-300 pt-6 mt-6" data-id="element-42">
        <p className="text-center text-gray-700 italic text-base max-w-3xl mx-auto" data-id="element-43">
          "LyraSleep is not only incredibly effective at night, but it's also
          100% safe and made with all-natural ingredients."
        </p>
      </div>
    </div>;
}